// material-ui
import { Grid, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

// project import
import AuthChangePassword from './auth-forms/AuthChangePassword';
import AuthWrapper from './AuthWrapper';
import Logo from 'components/Logo/Logo';

// ================================|| LOGIN ||================================ //

const ChangePassword = () => (
  <AuthWrapper>
    <Grid container spacing={3}>
    <>
        <Logo />
      </>
      <Grid item xs={12}>
        <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: { xs: -0.5, sm: 0.5 } }}>
          <Typography variant="h3">Reset Password </Typography>

            </Stack><Typography variant="h6">( OTP send on your registered email / mobile number )</Typography>
      </Grid>
      <Grid item xs={12}>
        <AuthChangePassword />

        <Typography component={Link} to="/login" variant="body1" sx={{ textDecoration: 'none' }} color="primary">
                    Login
        </Typography>
      </Grid>
    </Grid>
  </AuthWrapper>
);

export default ChangePassword;
